import React from 'react';
import { EmployeesBioSection } from './employeeBio';
import { WagesSection } from './wages';
import { EmployeesActivitySection } from './employeeActivity';
import { ContractorsSection } from './contractors';
import { TotalCostsSection } from './totalCosts';
export { Navigation } from './Navigation';
export function urlToSubpage(accountType, pageUrl, claim, refreshClaim, setClaim, debouncedSaveClaim, totalPayrollCostInvalid, saveClaim, project) {
  const urlToSubpageComponent = {
    'employees_bio': () => /*#__PURE__*/React.createElement(EmployeesBioSection, {
      project: project,
      accountType: accountType,
      claim: claim,
      refreshClaim: refreshClaim
    }),
    'wages': () => /*#__PURE__*/React.createElement(WagesSection, {
      project: project,
      claim: claim,
      accountType: accountType,
      refreshClaim: refreshClaim,
      debouncedSaveClaim: debouncedSaveClaim,
      setClaim: setClaim,
      totalPayrollCostInvalid: totalPayrollCostInvalid
    }),
    'employees_activity': () => /*#__PURE__*/React.createElement(EmployeesActivitySection, {
      project: project,
      accountType: accountType,
      claim: claim,
      refreshClaim: refreshClaim
    }),
    'contractors': () => /*#__PURE__*/React.createElement(ContractorsSection, {
      project: project,
      accountType: accountType,
      claim: claim,
      refreshClaim: refreshClaim,
      setClaim: setClaim,
      debouncedSaveClaim: debouncedSaveClaim
    }),
    'total_costs': () => /*#__PURE__*/React.createElement(TotalCostsSection, {
      accountType: accountType,
      claim: claim,
      setClaim: setClaim,
      refreshClaim: refreshClaim,
      saveClaim: saveClaim
    })
  };
  return urlToSubpageComponent[pageUrl]();
}